import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Custom = () => { 
    const params = useParams();
    const shortURL = params.custom;
    const [data, setData] = useState({ hits: [] });

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetch(`http://api.mcro.in/link/${shortURL}`);
            const data = await result.json();
            console.log(data);
            if (data) {
                if (data.length == 0) {
                    console.log('null');
                }
                else {
                    const longLink = 'http://' + data[0].mainLink.replace('https://','').replace('http://');

                    setData(longLink);
                    console.log(longLink);
                    window.location.replace(longLink);
                }
            }
        };

        fetchData();
    }, []);

    return (
        <h4>Loading....</h4>
    )
}

export default Custom;